class Header {
  constructor(parent) {
    if (!parent) return;
    this.parent = parent;
    this.clickEvent();
    console.log('header loaded');
  }
  clickEvent = () => {
    let parent = this.parent;
    let menuLinks = qsa('#menu-drawer .menu-levels-first',parent);
    menuLinks.length > 0 && menuLinks.forEach(link => {
      link.addEventListener('click',(e)=> {
        setTimeout(() => {
          menuLinks.forEach(inLink => {
            if (inLink != link) {
              inLink.closest('details').removeAttribute('open');
            }
          }); 
        },200);
      })
    });
    let menuDrawerClose = qs('#menu-drawer .menu-drawer-close',parent);
    let details = qsa('#menu-drawer details',parent);
    menuDrawerClose && menuDrawerClose.addEventListener('click',()=> {
      details.length > 0 && details.forEach(el=> {
        el.removeAttribute('open');
        el.classList.remove('menu-opening');
      })

      // 🔥 Remove all `submenu-open` classes
      let submenus = qsa('.menu-drawer__menu.has-submenu.submenu-open', parent);
      if (submenus.length > 0) {
        submenus.forEach(submenu => submenu.classList.remove('submenu-open'));
      }

      qs('body')?.classList.remove('overflow-hidden');
    })
  }
}

new Header(qs('.section-header'))